<template>
  <div class="attachments-list">
    <div
      v-for="(item, itemIndex) in attachments"
      :key="'attachment-' + itemIndex"
      class="attachment-card"
    >
      <div class="attachment-item-value">
        <v-icon left>mdi-file-pdf</v-icon>
        {{ item.fileName }}
      </div>


      <div class="attachment-actions">
        <!-- View Button -->
        <v-btn
          class="attachment-view-btn"
          color="primary"
          icon
          small
          @click="viewAttachment(item)"
        >
          <v-icon color="var(--app-dark-primary-color)">mdi-eye</v-icon>
        </v-btn>

        <!-- Delete Button -->
        <v-btn
          v-if="!disableDelete"
          class="attachment-remove-btn"
          color="red"
          icon
          small
          @click="confirmDelete(itemIndex)"
        >
          <v-icon color="var(--app-dark-primary-color)">mdi-delete</v-icon>
        </v-btn>
      </div>
    </div>

    <!-- Delete Confirmation Modal -->
    <naj-confirmation
      :show-modal="deleteConfirmationVisibility"
      color="error"
      :title="local.common.removeConfirmation"
      :message="removeMessage"
      :ok-btn-label="local.common.remove"
      @ok="deleteAttachment"
      @cancel="hideDeleteModal"
    >
    </naj-confirmation>

    <!-- PDF Viewer Modal -->
    <pdf-modal
      v-if="selectedAttachment"
      ref="pdfModal"
      :share-point-id="selectedAttachment.fileId"
      :file-name="selectedAttachment.fileName"
      @modalClose="hideViewModal"
    ></pdf-modal>
  </div>
</template>

<script>
import PdfModal from '@/components/shared/pdf-modal/index.vue';

export default {
  name: 'AttachmentList',
  components: { PdfModal },
  props: {
    attachments: {
      type: Array,
      default: () => [],
    },
    disableDelete: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeAttachment: null,
      deleteConfirmationVisibility: false,
      selectedAttachment: null,
    };
  },
  computed: {
    removeMessage() {
      return this.local?.common?.dynamicRemoveConfirmationMessage?.(
        this.local?.attachments?.attachment
      );
    },
  },
  methods: {
    /** Trigger delete confirmation modal */
    confirmDelete(index) {
      this.activeAttachment = index;
      this.deleteConfirmationVisibility = true;
    },

    /** Actually deletes the attachment and emits update event */
    deleteAttachment() {
      const removed = this.attachments.splice(this.activeAttachment, 1);
      this.$emit('update:attachments', [...this.attachments]);
      this.$emit('attachment-removed', removed[0]);
      this.hideDeleteModal();
    },

    hideDeleteModal() {
      this.activeAttachment = null;
      this.deleteConfirmationVisibility = false;
    },

    /** Opens the viewer modal */
    viewAttachment(attachment) {
      this.selectedAttachment = attachment;
      this.$nextTick(() => {
        var modal = this.$refs.pdfModal;
        modal.showModal();
      });
    },

    hideViewModal() {
      this.selectedAttachment = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.attachments-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
}

.attachment-card {
  border: 1px solid #dbdbdb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fafafa;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  width: 220px;
}

.attachment-item-value {
  font-weight: 600;
  font-size: 14px;
  color: var(--app-dark-primary-color);
  word-break: break-word;
}

.attachment-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.attachment-view-btn,
.attachment-remove-btn {
  min-width: 32px !important;
  height: 32px !important;

  .v-icon {
    font-size: 18px;
  }
}

.attachment-remove-btn {
  &:disabled {
    background-color: #ccc !important;
    cursor: not-allowed;

    .v-icon {
      color: #999 !important;
    }
  }
}
</style>
